import {
    Box,
    Card,
    CardContent,
    CardActions,
    Typography,
    Chip,
    Select,
    MenuItem,
    FormControl,
    Avatar,
    Divider,
    Button,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { getTypeIcon, getTypeColor, getTypeLabel, getStatusColor, getStatusLabel } from './feedbackMeta';

function FeedbackCard({ item, onStatusChange, onDelete }) {
    return (
        <Card
            sx={{
                width: '100%',
                borderLeft: 4,
                borderColor: `${getTypeColor(item.typ)}.main`,
                opacity: item.status === 'erledigt' ? 0.6 : 1,
                transition: 'all 0.3s ease',
                '&:hover': {
                    boxShadow: 3,
                },
            }}
        >
            <CardContent>
                {/* Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, gap: 1.5 }}>
                        <Avatar sx={{ bgcolor: `${getTypeColor(item.typ)}.main` }}>
                            {getTypeIcon(item.typ)}
                        </Avatar>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                                {item.titel}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Von: <strong>{item.vname} {item.nname}</strong>
                            </Typography>
                        </Box>
                    </Box>
                    <Chip
                        label={getTypeLabel(item.typ)}
                        color={getTypeColor(item.typ)}
                        size="small"
                        sx={{ ml: 1 }}
                    />
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Beschreibung */}
                <Typography variant="body2" sx={{ mb: 2, whiteSpace: 'pre-wrap' }}>
                    {item.beschreibung}
                </Typography>

                {/* Datum */}
                <Typography variant="caption" color="text.secondary">
                    {new Date(item.erstellt_am).toLocaleDateString('de-DE', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                    })}
                </Typography>
            </CardContent>

            {/* Actions */}
            <CardActions sx={{ pt: 0, justifyContent: 'space-between' }}>
                <FormControl size="small" sx={{ minWidth: 150 }}>
                    <Select
                        value={item.status}
                        onChange={(e) => onStatusChange(item.id, e.target.value)}
                        sx={{ bgcolor: 'background.default' }}
                    >
                        <MenuItem value="neu">Neu</MenuItem>
                        <MenuItem value="in_bearbeitung">In Bearbeitung</MenuItem>
                        <MenuItem value="erledigt">Erledigt</MenuItem>
                    </Select>
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip
                        label={getStatusLabel(item.status)}
                        color={getStatusColor(item.status)}
                        size="small"
                    />
                    <Button
                        size="small"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={() => onDelete(item.id)}
                    >
                        Löschen
                    </Button>
                </Box>
            </CardActions>
        </Card>
    );
}

export default FeedbackCard;
